export default "__VITE_ASSET__CX5_vusb__"